import {
  INVOICE_FACTORING_STATUS_OVERVIEW,
  INVOICE_FACTORING_STATUS_TYPE_OVERVIEW
} from '../providers/Invoices/Invoices.model';

class FactoringUtils {
  /**
   *  Returns the capitalized first letter of a string
   *  @param value
   *  @returns string | udefined
   */
  static capitalizeFirstLetterCompany = (value: string | undefined): string => {
    if (!value) return '';

    switch (value) {
      case 'APEX':
        return 'Apex';

      default:
        return value;
    }
  };
  /**
   *  Returns status based on factoringStatus
   *  @param factoringStatus
   *  @returns string
   */
  static getReadableStatus = (factoringStatus: string): string | null => {
    return (
      INVOICE_FACTORING_STATUS_OVERVIEW[
        factoringStatus as INVOICE_FACTORING_STATUS_TYPE_OVERVIEW
      ] || null
    );
  };
}

export default FactoringUtils;
